export default __webpack_public_path__ + "static/gtm-725a51ecbb2da2bb6e86ed51b541d5ab.png";